import xlsx from 'xlsx'
import { store } from '@/configurations'
import { dataType } from '@/constants/data-type'
import { APP_LANGUAGE_SUPPORTS } from '@/constants/app';
import { formatFunctions, utilsFunction } from '@/helpers/functions'
import { ACCOUNT_TYPE } from '@/constants/auth';
import { lang_messages } from '@/actions/app/app.setting'

export const writeFileFunctions = {
  writeExeclFile
}

const useless = [dataType.BUY_SELL]

function getAccountType(type) {
  let text
  switch (type) {
    case ACCOUNT_TYPE.CASH:
      text = lang_messages.en.common_cash_account
      break
    case ACCOUNT_TYPE.MARGIN:
      text = lang_messages.en.common_margin_account
      break
    default:
      text = 'Account Type'
      break
  }
  return text.replaceAll(' ', '')
}

function renderRuleFunction(columnMap) {
  return {
    renderSymbol({ field, rowData, value }) {
      const { cellRendererParams } = columnMap[field]
      const { market, instrument } = cellRendererParams
      return market && instrument ? `${rowData[market] && rowData[instrument] ? rowData[market] + '.' + rowData[instrument] : '-'}` : value
    },
    renderStockName({ field, rowData }) {
      const { cellRendererParams } = columnMap[field]
      const { stockName, chineseStockName } = cellRendererParams
      const language = store.getState().app.language

      let text
      switch(language.lang) {
        case APP_LANGUAGE_SUPPORTS[0].id:
          text = rowData[chineseStockName] ? rowData[chineseStockName] : rowData[stockName] ? rowData[stockName] : '-'
          break
        case APP_LANGUAGE_SUPPORTS[1].id:
          text = rowData[chineseStockName] ? rowData[chineseStockName] : rowData[stockName] ? rowData[stockName] : '-'
          break
        default:
          text = rowData[stockName] ? rowData[stockName] : '-'
      }
      return text
    },
    renderFloating({ field, rowData, value }) {
      const { cellRendererParams } = columnMap[field]
      const { percent, floating } = cellRendererParams
      return (percent && floating) ? `${(Number(value) > 0 ? '+' : (Number(value) === 0 ? '' : '')) + formatFunctions.dataFormat(rowData[floating], dataType.CASH)}(${(Number(value) > 0 ? '+' : (Number(value) === 0 ? '' : '')) + utilsFunction.currencyFormatter(rowData[percent], 2)}%)` : value;
    },
    renderTransactionHistoryStatus({ field, rowData }) {
      const { colId } = columnMap[field]
      const language = store.getState().app.language

      let text
      switch (colId) {
        case 'common_transaction_type':
          text = language[`transType_${rowData.type}`]
          break;
        default:
          break;
      }
      return text
    }
  }
}

function writeExeclFile(options) {
  const { prefix = true, fileName = 'execl.xlsx', sheetName = 'sheet 1', data = [], columnDefs = [] } = options

  const { tradingAccountID, accountType } = store.getState().trade.currentTradingAccount

  const headers = []
  const columnMap = columnDefs.reduce((prev, next) => {
    if (!useless.includes(next.dataType)) {
      headers.push(next.field)
      prev[next.field] = next
    }
    return prev
  }, {})

  const renderRules = renderRuleFunction(columnMap)
  
  const jsonData = data?.map(item => {
    const itemData = {}
    Object.entries(item).forEach(([key, value]) => {
      const lineData = columnMap[key]
      if (lineData) {
        switch (lineData.dataType) {
          case dataType.SYMBOL:
            itemData[lineData.headerName] = renderRules.renderSymbol({ field: lineData.field, rowData: item, value })
            break
          case dataType.STOCK_NAME:
            itemData[lineData.headerName] = renderRules.renderStockName({ field: lineData.field, rowData: item })
            break
          case dataType.FLOATING_PL_PERCENT:
            itemData[lineData.headerName] = renderRules.renderFloating({ field: lineData.field, rowData: item, value })
            break
          case dataType.TRANSACTION_HISTORY_STATUS:
            itemData[lineData.headerName] = renderRules.renderTransactionHistoryStatus({ field: lineData.field, rowData: item })
            break
          default:
            itemData[lineData.headerName] = formatFunctions.dataFormat(value, lineData.dataType).toString()
        }
      }
    })
    return itemData
  }) || []

  const workBook = xlsx.utils.book_new()
  const sheet = xlsx.utils.json_to_sheet(jsonData, { header: headers.map(v => columnMap[v].headerName) })
  sheet['!cols'] = headers.map(() => ({ width: 23 }))
  xlsx.utils.book_append_sheet(workBook, sheet, sheetName)
  xlsx.writeFile(workBook, prefix ? [tradingAccountID, getAccountType(accountType), fileName].join('-') : fileName)
}
